import { Link } from 'react-router-dom';
import { Search, FileCheck, UserCheck, MessageSquare, ArrowRight, Shield, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const StepCard = ({ icon: Icon, title, description, step }) => (
  <div className="bg-white border border-slate-200 rounded-xl p-6 md:p-8 flex gap-6 items-start" data-testid={`step-${step}`}>
    <div className="flex-shrink-0">
      <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center text-white">
        <Icon className="w-6 h-6" />
      </div>
      <div className="text-center mt-2">
        <span className="text-xs font-semibold text-slate-400">PASO {step}</span>
      </div>
    </div>
    <div>
      <h3 className="font-manrope font-semibold text-xl text-slate-900 mb-2">{title}</h3>
      <p className="text-slate-600 leading-relaxed">{description}</p>
    </div>
  </div>
);

export const ComoFuncionaPage = () => {
  return (
    <div className="page-transition bg-slate-50 min-h-screen" data-testid="como-funciona-page">
      <div className="bg-white border-b border-slate-200">
        <div className="container-cni py-12 md:py-16 text-center">
          <Badge variant="secondary" className="bg-slate-100 text-slate-700 mb-4">
            Guía de Uso
          </Badge>
          <h1 className="font-manrope font-bold text-3xl md:text-4xl text-slate-900 mb-4">
            ¿Cómo Funciona?
          </h1>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg">
            Conoce cómo utilizar el Colegio Nacional de Inmobiliarios.
          </p>
        </div>
      </div>

      <div className="container-cni py-12">
        <Tabs defaultValue="cliente" className="max-w-4xl mx-auto">
          <TabsList className="grid w-full grid-cols-2 mb-8 bg-slate-100 p-1 rounded-lg">
            <TabsTrigger value="cliente" className="data-[state=active]:bg-white rounded-md" data-testid="tab-cliente">
              Soy Cliente
            </TabsTrigger>
            <TabsTrigger value="profesional" className="data-[state=active]:bg-white rounded-md" data-testid="tab-profesional">
              Soy Profesional
            </TabsTrigger>
          </TabsList>

          <TabsContent value="cliente">
            <div className="space-y-6">
              <StepCard 
                icon={Search} 
                title="Busca" 
                description="Utiliza nuestro buscador para encontrar profesionales inmobiliarios por nombre, ubicación, especialidad o rango."
                step={1}
              />
              <StepCard 
                icon={FileCheck} 
                title="Valida" 
                description="Verifica el estatus, credenciales y trayectoria del profesional. Toda la información está verificada por el CNI."
                step={2}
              />
              <StepCard 
                icon={UserCheck} 
                title="Conecta" 
                description="Envía una solicitud de contacto formal al profesional dentro de un marco profesional regulado."
                step={3}
              />
              <StepCard 
                icon={MessageSquare} 
                title="Recomienda" 
                description="Después de tu experiencia, deja una recomendación profesional para ayudar a otros usuarios."
                step={4}
              />
              <div className="text-center pt-6">
                <Link to="/buscar">
                  <Button className="bg-amber-500 hover:bg-amber-400 text-black font-bold">
                    Comenzar a Buscar
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              </div>
            </div>
          </TabsContent>

          <TabsContent value="profesional">
            <div className="space-y-6">
              <StepCard 
                icon={FileCheck} 
                title="Solicita tu Ingreso" 
                description="Completa el formulario de solicitud y envía la documentación requerida para iniciar tu proceso de validación."
                step={1}
              />
              <StepCard 
                icon={Shield} 
                title="Validación de Documentos" 
                description="Nuestro equipo verifica tu identidad, credenciales, certificaciones y afiliación a asociaciones reconocidas."
                step={2}
              />
              <StepCard 
                icon={Users} 
                title="Obtén tu Rango" 
                description="Basado en tu experiencia y formación, se te asigna un rango inicial que podrás mejorar con el tiempo."
                step={3}
              />
              <StepCard 
                icon={Search} 
                title="Aparece en el Registro" 
                description="Tu perfil verificado estará disponible en el directorio público, permitiendo que clientes te encuentren."
                step={4}
              />
              <div className="text-center pt-6">
                <Link to="/contacto">
                  <Button className="bg-amber-500 hover:bg-amber-400 text-black font-bold">
                    Solicitar Ingreso
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              </div>
            </div>
          </TabsContent>
        </Tabs>

        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-slate-900 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="font-manrope font-bold text-2xl text-white mb-4">
              ¿Tienes más preguntas?
            </h2>
            <p className="text-slate-300 mb-6">
              Contáctanos y resolveremos todas tus dudas sobre el CNI
            </p>
            <Link to="/contacto">
              <Button className="bg-white text-slate-900 hover:bg-slate-100">
                Contactar al CNI
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
